import {
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import industryfiltermobile from "../../../Assets/industryfiltermobile.svg";
import joiscorefiltermobile from "../../../Assets/joiscorefiltermobile.svg";
import revenuefiltermobile from "../../../Assets/revenuefiltermobile.svg";
import locationfiltermobile from "../../../Assets/locationfiltermobile.svg";
import sidearrowmobile from "../../../Assets/sidearrowmobile.svg";
import aiprofileiconMobile from "../../../Assets/aiprofileiconMobile.svg";
const LeadsFilterMobile = ({
  openFilterDrawer,
  setOpenFilterDrawer,
  setOpenFilterDetail,
  openFilterDetail,
  ResetFilterData,
  filterRegion,
  handleAccordionToggle,
  isRegionSelected,
  expandedRegions,
  handleCountryChange,
  isCountrySelected,
  aiLeadsFilters,
  selectedData,
  handleToggleIndustry,
  selectedCountries,
  showlast,
  handleToggleRevenue,
  jScoredata,
  handleToggleJScore,
  handleApply,
  isTabPortrait,
  AiProfileData,
  handleAiProFIleChange,
  aiProfileList,
  applyFilterProfile,
}) => {

  return (
    <Slide
      direction="left"
      in={openFilterDrawer}
      mountOnEnter
      unmountOnExit
      className="aip-filter-mb-slide"
    >
      <Box
        sx={{
          position: "fixed",
          top: isTabPortrait ? "33px" : "0",
          left: isTabPortrait ? "" : "0",
          width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
          right: isTabPortrait ? "0px" : "",
          height: "100vh",
          bgcolor: "white",
          zIndex: 10,
          boxShadow: 2,
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          overflowY: "auto",
            pb: 20,
        }}
      >
        <div className="m-2">
          {/* Panel Header */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            // px={2}
            py={1.5}
          >
            {openFilterDetail ? (
              <>
                <IconButton onClick={() => setOpenFilterDetail("")}>
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <Typography variant="subtitle1" fontWeight="bold">
                  {openFilterDetail}
                </Typography>
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#0004FF",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    ResetFilterData();
                    setOpenFilterDrawer(false);
                    setOpenFilterDetail("");
                  }}
                >
                  Clear All
                </Button>
              </>
            ) : (
              <>
                <IconButton onClick={() => setOpenFilterDrawer(false)}>
                  <ArrowBackIosNewIcon fontSize="small" />
                </IconButton>
                <Typography variant="subtitle1" fontWeight="bold">
                  Filters
                </Typography>
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#0004FF",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                  onClick={() => {
                    ResetFilterData();
                    setOpenFilterDrawer(false);
                  }}
                >
                  Clear All
                </Button>
              </>
            )}
          </Box>
          <Divider />

          {/* Filter Items */}
          {openFilterDetail ? (
            <>
              {openFilterDetail === "Location" &&
              Object.keys(filterRegion)?.length ? (
                <>
                  {Object.keys(filterRegion).map((region) => (
                    <div key={region} className="leads_loc_filter_inner">
                      <div
                        className={
                          isRegionSelected(region)
                            ? "AI-leader-checkbox-and-data-list location_filter_leads_cont_2"
                            : "AI-leader-checkbox-and-data-list location_filter_leads_cont"
                        }
                      >
                        <div className="checkbox-select-data">
                          <MenuItem className="menuitems">{region}</MenuItem>
                          <span onClick={() => handleAccordionToggle(region)}>
                            <KeyboardArrowDownIcon />
                          </span>
                        </div>
                      </div>
                      {expandedRegions.includes(region) && (
                        <div className="location_filter_leads">
                          <List sx={{ width: "100%", paddingBottom: "90px" }}>
                            {filterRegion[region].map((option) => {
                              return (
                                <ListItem
                                  key={option}
                                  button
                                  onClick={() => handleCountryChange(option)}
                                  sx={{
                                    bgcolor: isCountrySelected(option)
                                      ? "#4da6ff"
                                      : "white",
                                    color: isCountrySelected(option)
                                      ? "white"
                                      : "black",
                                    "&:hover": {
                                      bgcolor: isCountrySelected(option)
                                        ? "#3399ff"
                                        : "#f5f5f5",
                                    },
                                    fontWeight: isCountrySelected(option)
                                      ? "bold"
                                      : "normal",
                                    marginBottom: "5px",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <ListItemText primary={option} />
                                </ListItem>
                              );
                            })}
                            <div className="aip-mb-btn-cont">
                              <Button
                                sx={{
                                  textTransform: "none",
                                  color: "#000000",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                }}
                                onClick={() => {
                                  ResetFilterData();
                                  setOpenFilterDrawer(false);
                                }}
                              >
                                Reset
                              </Button>
                              <button
                                className="aip-apply-mb"
                                onClick={() => {
                                  handleApply();
                                  setOpenFilterDetail("");
                                  setOpenFilterDrawer(false);
                                }}
                              >
                                <DoneIcon className="aip-mb-apply-tick-icon" />
                                <span
                                  className="mb-AileadsFilter-Apply-button"
                                  variant="contained"
                                >
                                  Apply
                                </span>
                              </button>
                            </div>
                          </List>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              ) : openFilterDetail === "Industry" &&
                aiLeadsFilters?.data?.categories ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiLeadsFilters?.data?.categories.map((option) => {
                      const isSelected = selectedData.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleIndustry(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Reset
                      </Button>

                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          handleApply();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : openFilterDetail === "Revenue" &&
                aiLeadsFilters?.data?.revenue_range ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiLeadsFilters?.data?.revenue_range.map((option) => {
                      const isSelected = showlast.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleRevenue(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Reset
                      </Button>
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          handleApply();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : openFilterDetail === "JOI Score" &&
                aiLeadsFilters?.data?.j_score?.slice(1) ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiLeadsFilters?.data?.j_score?.slice(1).map((option) => {
                      const isSelected = jScoredata.includes(option);
                      return (
                        <ListItem
                          key={option}
                          button
                          onClick={() => handleToggleJScore(option)}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={option} />
                        </ListItem>
                      );
                    })}
                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Reset
                      </Button>
                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          handleApply();
                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span
                          className="mb-AileadsFilter-Apply-button"
                          variant="contained"
                        >
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : openFilterDetail === "AI Profile" && aiProfileList?.length ? (
                <>
                  <List sx={{ width: "100%", paddingBottom: "90px" }}>
                    {aiProfileList.map((item) => {
                      const isSelected = AiProfileData === item.name;

                      return (
                        <ListItem
                          key={item.id}
                          button
                          onClick={() => {
                            handleAiProFIleChange({
                              target: { value: item.name },
                            });
                          }}
                          sx={{
                            bgcolor: isSelected ? "#4da6ff" : "white",
                            color: isSelected ? "white" : "black",
                            "&:hover": {
                              bgcolor: isSelected ? "#3399ff" : "#f5f5f5",
                            },
                            fontWeight: isSelected ? "bold" : "normal",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <ListItemText primary={item.name} />
                        </ListItem>
                      );
                    })}

                    <div className="aip-mb-btn-cont">
                      <Button
                        sx={{
                          textTransform: "none",
                          color: "#000000",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          ResetFilterData();
                          setOpenFilterDrawer(false);
                        }}
                      >
                        Reset
                      </Button>

                      <button
                        className="aip-apply-mb"
                        onClick={() => {
                          const selectedItem = aiProfileList.find(
                            (profile) => profile.name === AiProfileData,
                          );

                          if (selectedItem) {
                            applyFilterProfile(selectedItem);
                          }

                          setOpenFilterDetail("");
                          setOpenFilterDrawer(false);
                        }}
                      >
                        <DoneIcon className="aip-mb-apply-tick-icon" />
                        <span className="mb-AileadsFilter-Apply-button">
                          Apply
                        </span>
                      </button>
                    </div>
                  </List>
                </>
              ) : null}
            </>
          ) : (
            <List>
              <ListItem
                button
                style={{ borderBottom: "1px solid #C8C9C7" }}
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {selectedCountries?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {selectedCountries?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Location");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={locationfiltermobile} alt="" />

                  {/* <LocationOnOutlinedIcon /> */}
                </ListItemIcon>
                <ListItemText primary="Location" />
              </ListItem>

              <ListItem
                style={{ borderBottom: "1px solid #C8C9C7" }}
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {selectedData?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {selectedData?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Industry");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={industryfiltermobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="Industry" />
              </ListItem>

              <ListItem
                style={{ borderBottom: "1px solid #C8C9C7" }}
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {showlast?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {showlast?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("Revenue");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={revenuefiltermobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="Revenue" />
              </ListItem>

              <ListItem
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {jScoredata?.length ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        {jScoredata?.length} Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("JOI Score");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={joiscorefiltermobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="JOI Score" />
              </ListItem>

              <ListItem
                button
                secondaryAction={
                  <Box display="flex" alignItems="center" gap={1}>
                    {AiProfileData ? (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize="1rem"
                      >
                        1 Selected
                      </Typography>
                    ) : null}
                    <img src={sidearrowmobile} alt="" />{" "}
                  </Box>
                }
                onClick={() => {
                  setOpenFilterDetail("AI Profile");
                }}
              >
                <ListItemIcon style={{ minWidth: "30px" }}>
                  <img src={aiprofileiconMobile} alt="" />
                </ListItemIcon>
                <ListItemText primary="AI Profile" />
              </ListItem>
            </List>
          )}
          {/* {openFilterDetail ?   (
         
          ):null} */}
        </div>
      </Box>
    </Slide>
  );
};
export default LeadsFilterMobile;
